// @flow
// TODO: maybe split Passenger type and Accepted utils
import passengersCountHash from "./passengersCountHash"
import type { Passengers } from "booking/services/reservation/types"

type AcceptedConfig = Map<string, number>

type Props = {
  origAccepted: AcceptedConfig,
  passengers: Passengers,
  price: number,
}

// update customer accepted prices config
// { "1-0-1": 10 } -> customer accepts price for adult and infant for 10 eur
export const updateAcceptedPricesConfig = ({
  origAccepted,
  passengers,
  price,
}: Props): AcceptedConfig => origAccepted.set(passengersCountHash(passengers), price)
